import { useState, useEffect, createContext, useContext } from "react";
import { TranslatorProvider } from "react-translate";
import en from "./utils/i18n/en";
import es from "./utils/i18n/es";

const translations = { en, es };

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("en");

  // Load saved language on mount
  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang && translations[savedLang]) {
      setLangState(savedLang);
    }
  }, []);

  // Save to localStorage whenever lang changes
  const setLang = (newLang) => {
    localStorage.setItem("lang", newLang);
    setLangState(newLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      <TranslatorProvider translations={translations[lang]} locale={lang}>
        {children}
      </TranslatorProvider>
    </LanguageContext.Provider>
  );
};
